"use client";

import { useViewedScreen } from "@packages/analytics";
import type { Pages } from "@packages/sdk";
import { useRequestPages, useSession } from "@packages/sdk";
import { Section, Sections } from "@packages/ui";

import { LoadingPage } from "../../../../components/LoadingPage";

type PageClientProps = {
  initialData: Pages;
  page: string;
};

export const PageClient = ({ initialData, page }: PageClientProps) => {
  const { status } = useSession();
  const { query: queryPage } = useRequestPages({
    initialData,
    page,
  });

  if (queryPage.isLoading) return <LoadingPage />;

  useViewedScreen({
    screen: "page_detail",
    properties: {
      page_id: page,
      name: queryPage.data?.name,
    },
    isReady:
      status === "unauthenticated" ||
      (status === "authenticated" && !!queryPage.data?.name),
  });

  return (
    <Sections title={queryPage.data?.name}>
      {queryPage.data?.sections.map((section) => (
        <Section key={section.id} section={section} pageId={parseInt(page)} />
      ))}
    </Sections>
  );
};
